import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Principal } from './principal.service';

@Injectable()
export class UserRouteAccessService implements CanActivate {

    constructor(
        private router: Router,
        private principal: Principal
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Promise<boolean> {
        return this.checkLogin(state.url);
    }

    checkLogin(url: string): Promise<boolean> {
        return this.principal.identity().then((account) => {
            if (account) {
                return true;
            }
            sessionStorage.setItem('redirectUrl', url);
            this.router.navigate(['login']);
            return false;
        });
    }
}
